export default __webpack_public_path__ + "3eff77c14906110997fd209463f87d59.png";